import { inf_partner } from './inf_users';

export const updated_form_data = (key: any, value: any, formData: any) => {
    const update_form = {
        ...formData,
        [key]: value
    };
    return update_form;
};

export const validate_data = (name: string, value: any, formData: any) => {
    var error = '';
    var regexEmail = /^\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\s*,\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*\s*$/;
    var regexPhone = /^[0-9]{10}$/;
    var infPartner;

    switch (name) {
        case 'fullusername':
            if (!value) {
                error = 'El campo es "Nombre Completo", es obligatorio';
            }
            break;

        case 'username':
            if (!value) {
                error = 'El campo es "Usuario", es obligatorio';
            }
            break;

        case 'email':
            if (!regexEmail.test(value?.trim())) {
                error = "El correo electrónico proporcionado no tienen un formato válido.";
            }
            break;

        case 'phone':
            if (!value) {
                error = 'El campo "Teléfono" es obligatorio';
            } else if (!regexPhone.test(value.trim())) {
                error = "El número de teléfono debe contener exactamente 10 dígitos numéricos.";
            }
            break;

        case 'job':
            if (!value) {
                error = 'El campo es "Puesto", es obligatorio';
            }
            break;

    }

    return { error: error, objetUpdate: infPartner === undefined ? inf_partner : infPartner };
};

export const processed_format = (formData: any) => {
    const dataToSubmit = { ...formData };
    delete dataToSubmit.pointofsale;
    delete dataToSubmit.system_commentary;
    delete dataToSubmit.date_register;

    return dataToSubmit;
};

export const create_object = {
    username: null,
    fullusername: null,
    phone: null,
    job: null,
    email: null,
}